import { QUERY_KEYS_SERVICE_AGREEMENTS } from 'api/query-keys';
import { serviceAgreementsService } from 'ogp/services';
import {
  ServiceAgreementFilterPayload,
  ServiceAgreementsResponse,
} from 'ogp/services/service-agreements.types';
import { useQuery } from 'react-query';

export const useGetServiceAgreementsForCompany = (relation?: ServiceAgreementFilterPayload) => {
  const queryFn = async () =>
    await serviceAgreementsService.getServiceAgreementsForCompany(relation);

  return useQuery<ServiceAgreementsResponse, Error, ServiceAgreementsResponse>(
    [...QUERY_KEYS_SERVICE_AGREEMENTS.serviceAgreementsForCompany(), relation ?? {}],
    queryFn
  );
};
